import { FormControl, FormLabel, HStack, Input } from "@chakra-ui/react";
import CodesetSelect from "./CodesetSelect";

const RateAmountInput = ({
  label,
  value,
  onChange,
  size = "md",
  height = "auto",
}) => {
  const handleUnitCodeChange = (selected) => {
    onChange({
      ...value,
      unitCode: selected?.code || "",
    });
  };

  const handleValueChange = (e) => {
    onChange({
      ...value,
      value: parseFloat(e.target.value) || 0,
    });
  };

  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}
      <HStack spacing={2}>
        <CodesetSelect
          codesetCode="6411"
          filter="#Rate"
          value={
            value?.unitCode ? { code: value.unitCode, description: "" } : null
          }
          onChange={handleUnitCodeChange}
          size={size}    // ✅ pass size
          height={height} // ✅ pass height
        />
        <Input
          placeholder="Rate"
          type="number"
          width="200px"
          textAlign="right"
          pattern="[0-9]*"
          inputMode="numeric"
          autoComplete="off"
          autoCorrect="off"
          spellCheck="false"
          autoCapitalize="off"
          size={size}     // ✅ use size
          height={height} // ✅ use height
          value={value?.value || ""}
          onChange={handleValueChange}
        />
      </HStack>
    </FormControl>
  );
};

export default RateAmountInput;
